import ReactToPrint from 'react-to-print';
import { BASE_URL, FRONTEND_URL } from "../../../config/axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import numberToWords from 'number-to-words';
import { ViewBill } from './ExpenseSlipComponents';
import { formattedDate, formattedDateLong } from '../../Date';
import { PendingCheckBox, Printer } from '../../AllSvg';
import { formatRoundoff2D } from '../../CustomFunctions';

const ExpenseSlip = React.forwardRef((props, ref) => {

  const location = useLocation();
  const { i } = location.state;
  const [imprestData, setImprestData] = useState({})
  const [expenseDetailsData, setExpenseDetailsData] = useState([])
  const [personalData, setPersonalData] = useState({})

  // console.log('expense data i =: ', i)
  // console.log('expenseDetailsData: ', expenseDetailsData)


  const totalImprestAsked = Number(i.imprest_data?.grocery) + Number(i.imprest_data?.stationary_item) + Number(i.imprest_data?.electronic_item) +
    (i.imprest_data?.other_details?.length > 0
      ? i.imprest_data?.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
      : 0);
  const totalImprestAskedWords = numberToWords.toWords(totalImprestAsked ? totalImprestAsked : 0);

  const totalImprestApproved = Number(i.imprest_data?.approved_grocery) + Number(i.imprest_data?.approved_stationary_item) + Number(i.imprest_data?.approved_electronic_item) +
    (i.imprest_data?.other_details?.length > 0
      ? i.imprest_data?.other_details.reduce((total, other) => total + Number(other.approved_other || 0), 0)
      : 0);
  const totalImprestApprovedWords = totalImprestApproved ? numberToWords.toWords(totalImprestApproved) : numberToWords.toWords(0);

  const [expensesum, setExpenseSum] = useState(0)
  const [sum, setSum] = useState(0)
  const [dates, setDates] = useState(0)


  const [groceryTotal, setGroceryTotal] = useState(0);
  const [stationaryTotal, setStationaryTotal] = useState(0);
  const [electronicTotal, setElectronicTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);

  const [approvedGroceryTotal, setApprovedGroceryTotal] = useState(0);
  const [approvedStationaryTotal, setApprovedStationaryTotal] = useState(0);
  const [approvedElectronicTotal, setApprovedElectronicTotal] = useState(0);
  const [approvedOtherTotal, setApprovedOtherTotal] = useState(0);
  const [amountsApproved, setAmountsApproved] = useState(false)


  const [buffer, setBuffering] = useState(true); //buffering logic

  const getLetterData = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/expensedetailsbyexpense/${i.id}/`);
      setExpenseDetailsData(res.data)
      setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
      setAmountsApproved(res.data.some(expense => expense.bill_approved_amt === null))

      const summ = res.data.some(expense => expense.bill_approved_amt === null)
        ? res.data.reduce((acc, item) => acc + parseFloat(item.item_amount || 0), 0)
        : res.data.reduce((acc, item) => acc + parseFloat(item.bill_approved_amt || 0), 0);
      setSum(summ)

      const expsumm = res.data.reduce((acc, item) => acc + parseFloat(item.item_amount), 0);
      setExpenseSum(expsumm)

      res.data.forEach(item => {
        const amount = Number(item.item_amount);
        const approvedAmount = Number(item.bill_approved_amt);

        const isOtherItem = i.imprest_data?.other_details?.some(
          other => other.other_name === item.expense_type
        );

        if (isOtherItem) {
          setOtherTotal(prevTotal => prevTotal + amount);
          setApprovedOtherTotal(prevTotal => prevTotal + (approvedAmount || 0));
        } else {
          switch (item.expense_type) {
            case 'Grocery':
              setGroceryTotal(prevTotal => prevTotal + amount);
              setApprovedGroceryTotal(prevTotal => prevTotal + approvedAmount);
              break;
            case 'Stationary':
              setStationaryTotal(prevTotal => prevTotal + amount);
              setApprovedStationaryTotal(prevTotal => prevTotal + approvedAmount);
              break;
            case 'Electronic':
              setElectronicTotal(prevTotal => prevTotal + amount);
              setApprovedElectronicTotal(prevTotal => prevTotal + approvedAmount);
              break;
            default:
              setOtherTotal(prevTotal => prevTotal + amount);
              setApprovedOtherTotal(prevTotal => prevTotal + (approvedAmount || 0));
              break;
          }
        }
      });

      const ress = await axios.get(`${BASE_URL}/siteproject/employeebyempid/${i.emp_account_detail}/`)
      setPersonalData(ress.data)

      const resss = await axios.get(`${BASE_URL}/siteproject/imprestbyid/${i.imprest}/`)
      setImprestData(resss.data)

    } catch (err) {
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    getLetterData();
  }, []);




  return (
    <div className='' ref={ref}>
      <div className='printSlip '>
        {buffer ? <div className="spinner-bgdatil"></div> : null}{/* //buffering logic */}
        <div className='printSlip-header'>
          <div className='printSlip-header-left'>
            <img src="https://cipl-aimantra.s3.ap-south-1.amazonaws.com/Logos/Cipl+Logo++(1).png" alt='logo' className='printSlip-logo' />

            <div className='printSlip-header-left-text  font-size-heading'>
              Expense Slip For : "{i.name}"
            </div>
          </div>
          <div className='printSlip-header-right'>
            <div className='printSlip-header-right-top  font-weight600   font-size-heading'>
              Civilmantra infracon private limited
            </div>
            <div className='printSlip-header-right-bottom  font-weight400  font-size-subheading'>
              3rd Floor, Tower 3A,<br /> DLF Corporate Greens, Sector 74A,<br /> Gurugram, Haryana 122004 <br /> services@civilmantra.com
            </div>
          </div>
        </div>
        <div className='printSlip-hr'></div>
        <div className='printSlip-header-second'>
          <div className='printSlip-header-second-section1'>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>Project Name</div>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>Employee Code</div>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>Designation</div>
          </div>
          <div className='printSlip-header-second-section2'>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{i.project_name}</div>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{personalData.emp_code}</div>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{personalData.designation_name}</div>
          </div>
          <div className='printSlip-header-second-section3'>
          </div>
          <div className='printSlip-header-second-section4'>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>Name</div>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>Start Date</div>
            <div className='printSlip-heading-black font-weight600 font-size-subheading'>End Date</div>
          </div>
          <div className='printSlip-header-second-section5'>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{personalData.name}</div>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{dates.length == 0 ? "Expense Details Pending " : formattedDateLong(dates[0])}</div>
            <div className='printSlip-heading-black1 font-weight400 font-size-subheading'>{dates.length == 0 ? "Expense Details Pending " : formattedDateLong(dates[dates.length - 1])}</div>
          </div>
        </div>

        <div className='printSlip-body'>
          <tr>
            <th className='printSlip-heading-blue font-weight500 font-size-subheading'>Imprest: </th>
            {/* <td colSpan={5} style={{ paddingLeft: "30px" }} className='form-text-trasformation-uppercase'>{totalImprestAskedWords}</td> */}
          </tr>

          <table className='printSlip-table'>
            <thead>
              <tr className='printSlip-head'>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'></th>
                {Number(imprestData.grocery) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Grocery</th>}
                {Number(imprestData.stationary_item) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Stationary</th>}
                {Number(imprestData.electronic_item) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Electronics</th>}
                {imprestData.other_details?.length > 0
                  ?
                  <>
                    {imprestData.other_details.map((other, index) => (
                      <th style={{ padding: "0px 5px" }} className='printSlip-table-td form-text-trasformation-uppercase'>{other.other_name ? other.other_name : `Other-${index + 1}`}</th>
                    ))}
                  </>
                  : null}
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Grand Total</th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                <tr>
                  <td className='printSlip-heading-blue font-weight500 font-size-subheading'>Asked</td>
                  {Number(imprestData.grocery) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.grocery)}</td>}
                  {Number(imprestData.stationary_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.stationary_item)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.electronic_item)}</td>}
                  {imprestData.other_details?.length > 0
                    ?
                    imprestData.other_details?.map((other, index) => (
                      <td className='printSlip-table-td'>{formatRoundoff2D(other.amount || 0)}</td>
                    ))
                    : null}
                  <td className='printSlip-table-td '>{formatRoundoff2D(totalImprestAsked)}</td>
                </tr>
                {/* <tr>
                      <td colSpan={6} className='printSlip-hrr'></td>
                    </tr> */}
                <tr>
                  <td className='printSlip-heading-blue font-weight500 font-size-subheading'>Approved</td>
                  {Number(imprestData.grocery) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_grocery)}</td>}
                  {Number(imprestData.stationary_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_stationary_item)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(imprestData.approved_electronic_item)}</td>}
                  {/* <td className='printSlip-table-td'>{imprestData.approved_other}</td> */}
                  {imprestData.other_details?.length > 0
                    ?
                    imprestData.other_details?.map((other, index) => (
                      <td className='printSlip-table-td'>{formatRoundoff2D(other.approved_other || 0)}</td>
                    ))
                    : null}
                  <td className='printSlip-table-td '>{formatRoundoff2D(totalImprestApproved)}</td>
                </tr>

              </React.Fragment>

              <tr>
                <td colSpan={65} className='printSlip-hrr'></td>
              </tr>
            </tbody>
          </table>
          {/* <br /> */}
          <tr style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <th>Grand Total</th>
              <td colSpan={5} style={{ paddingLeft: "30px" }} className='form-text-trasformation-uppercase'>{formatRoundoff2D(totalImprestApproved)}</td>
            </div>
            <div>
              <th>IN WORDS</th>
              <td colSpan={5} style={{ paddingLeft: "30px" }} className='form-text-trasformation-uppercase'>{totalImprestApprovedWords}</td>
            </div>
          </tr>
          <br />
          <table className='printSlip-table'>
            <thead>
              <tr>
                <th className='printSlip-heading-blue font-weight500 font-size-subheading'>Expense: </th>
              </tr>
              <tr className='printSlip-head'>
                <th style={{ padding: "0px 5px" }} ></th>
                {/* {Number(imprestData.grocery) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Grocery</th>}
                {Number(imprestData.stationary_item) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Stationary</th>}
                {Number(imprestData.electronic_item) > 0 && <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Electronics</th>}
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Others</th> */}
                {expenseDetailsData.length > 0
                  ? Object.entries(
                    expenseDetailsData.reduce((acc, item) => {
                      const type = item.expense_type;
                      const amount = parseFloat(item.item_amount) || 0;
                      acc[type] = (acc[type] || 0) + amount;
                      return acc;
                    }, {})
                  ).map(([expenseType, totalAmount]) => (
                    <th className='printSlip-table-td' key={expenseType}>
                      {expenseType}
                    </th>
                  ))
                  : null}
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Grand Total</th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                <tr>
                  {/* <td className='printSlip-heading-blue font-weight500 font-size-subheading' style={{ width: '200px' }}>{personData}</td> */}
                  {/* <th style={{ padding: "0px 5px" }} ></th> */}
                  <td className='printSlip-heading-blue font-weight500 font-size-subheading'>Asked</td>
                  {/* {Number(imprestData.grocery) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(groceryTotal)}</td>}
                  {Number(imprestData.stationary_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(stationaryTotal)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(electronicTotal)}</td>}
                  <td className='printSlip-table-td'
                    title={expenseDetailsData
                      .filter(other => !['Grocery', 'Stationary', 'Electronic'].includes(other.expense_type))
                      .map((other, index) => `${other.item_name} (${other.expense_type}) : ${formatRoundoff2D(other.item_amount)}`)
                      .join('\n')
                    }
                  >{formatRoundoff2D(otherTotal)}</td> */}
                  {expenseDetailsData.length > 0
                    ? Object.entries(
                      expenseDetailsData.reduce((acc, item) => {
                        const type = item.expense_type;
                        const amount = parseFloat(item.item_amount) || 0;
                        acc[type] = (acc[type] || 0) + amount;
                        return acc;
                      }, {})
                    ).map(([expenseType, totalAmount]) => (
                      <td className='printSlip-table-td' key={expenseType}>
                        {formatRoundoff2D(totalAmount)}
                      </td>
                    ))
                    : null}
                  <td className='printSlip-table-td '>{formatRoundoff2D(expensesum)}</td>
                </tr>
                <tr>
                  {/* <td className='printSlip-heading-blue font-weight500 font-size-subheading' style={{ width: '200px' }}>{personData}</td> */}
                  {/* <th style={{ padding: "0px 5px" }} ></th> */}
                  <td className='printSlip-heading-blue font-weight500 font-size-subheading'>Approved</td>
                  {/* {Number(imprestData.grocery) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(approvedGroceryTotal)}</td>}
                  {Number(imprestData.stationary_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(approvedStationaryTotal)}</td>}
                  {Number(imprestData.electronic_item) > 0 && <td className='printSlip-table-td'>{formatRoundoff2D(approvedElectronicTotal)}</td>}
                  <td className='printSlip-table-td'
                    title={expenseDetailsData
                      .filter(other => !['Grocery', 'Stationary', 'Electronic'].includes(other.expense_type))
                      .map((other, index) => `${other.item_name} (${other.expense_type}) : ${formatRoundoff2D(other.bill_approved_amt)}`)
                      .join('\n')
                    }
                  >{formatRoundoff2D(approvedOtherTotal)}</td> */}
                  {expenseDetailsData.length > 0
                    ? Object.entries(
                      expenseDetailsData.reduce((acc, item) => {
                        const type = item.expense_type;
                        const amount = parseFloat(item.bill_approved_amt) || 0;
                        acc[type] = (acc[type] || 0) + amount;
                        return acc;
                      }, {})
                    ).map(([expenseType, totalAmount]) => (
                      <td className='printSlip-table-td' key={expenseType}>
                        {formatRoundoff2D(totalAmount)}
                      </td>
                    ))
                    : null}
                  <td className={`printSlip-table-td ${amountsApproved ? 'request-status' : ''}`} request-status={amountsApproved ? 'pending' : ''} >{amountsApproved ? "Approvals Pending" : formatRoundoff2D(sum)}</td>
                </tr>
              </React.Fragment>
              <br />

              <tr>
                <td colSpan={65} className='printSlip-hrr'></td>
              </tr>
            </tbody>
          </table>
          <table className='printSlip-table'>

            <thead style={{ margin: "20px 0px" }}>
              <tr className='printSlip-head' >
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Sr No.</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Date</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Name</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Amount</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Approved Amt.</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Expense Type</th>
                <th style={{ padding: "0px 5px" }} className='printSlip-table-td'>Bills</th>
              </tr>
            </thead>

            <tbody>

              {expenseDetailsData
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((j, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="8"></td>
                    </tr>
                    <tr>
                      <td className='printSlip-table-td'>{index + 1}</td>
                      <td className='printSlip-table-td'>{formattedDateLong(j.date)}</td>
                      <td className='printSlip-table-td'>{j.item_name}</td>
                      <td className='printSlip-table-td'>{j.item_amount}</td>
                      {/* <td className='printSlip-table-td' title={`${j.bill_amount_change_reason ? j.bill_amount_change_reason : ""}`}>
                        {j.bill_approved_amt ? j.bill_approved_amt : "-"}
                      </td> */}

                      <td className='printSlip-table-td ' title={`${j.bill_amount_change_reason ? `Amount Change Reason: \n${j.bill_amount_change_reason}` : ""}`}>
                        {j.bill_approved_amt ?
                          j.bill_approved_amt === "0" && j.bill_approved === "rejected" ?
                            <div title={`${j.bill_amount_change_reason ? `Amount Change Reason: \n${j.bill_amount_change_reason}\n` : ""}${j.bill_approved === "rejected" ? `Bill Reject Reason: \n${j.bill_rejection_reason}` : ""}`} style={{ textDecoration: 'line-through' }}>{j.authority_approved_amt}</div>
                            : j.bill_approved_amt
                          :
                          "-"
                        }</td><td className='printSlip-table-td'>{j.expense_type}</td>
                      <td className={`printSlip-table-td ${i.dynamic_approval?.some(da => da.approval_status !== "pending" && da.permissions === "Approve-Reject-Edit") ? 'flex-row' : ''}`}>
                        {j.bill ?
                          <>
                            <ViewBill i={j} />
                            {i.dynamic_approval?.some(da => da.permissions === "Approve-Reject-Edit" && da.approval_status !== "pending") ?
                              // {j.account_status_a !== "pending" ?
                              j.bill_approved !== "pending" ?
                                j.bill_approved === "approved" ?
                                  <div title="Bill Approved" className="expense-status-approved">✓</div>
                                  : <span
                                    title={`Bill Rejection Reason: \n${j.bill_rejection_reason}`}
                                    className="expense-status-rejected"
                                  >
                                    ✕
                                  </span>
                                :
                                <div title='Bill Check Pending'>
                                  <PendingCheckBox color={"#707070"} />
                                </div>
                              //   <div
                              //   title="Pending Verification"
                              //   className="expense-status-pending"
                              // />
                              : null

                            }
                          </>

                          : " No bill"}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              <tr>
                <td colSpan={8} className='printSlip-hrr'></td>
              </tr>
            </tbody>
          </table>

          <tr>
            <th >TOTAL </th>
            <td className='printSlip-table-td'>{sum}</td>
          </tr>
          <tr>
            <th className='printSlip-heading-blue font-weight500 font-size-subheading'>IN WORDS</th>
            <td colSpan={5} style={{ paddingLeft: "30px" }} className='form-text-trasformation-uppercase'>{numberToWords.toWords(sum)}</td>
          </tr>

        </div>
        <div className='printSlip-hr'></div>
        <h6 style={{ fontSize: '10px' }}><b>*This is Software generated Expense Slip no signature required*</b></h6>
      </div>
      <div className='printSlip-bg'>


      </div>
    </div >
  )
});

const ExpenseSlipByExpense = () => {
  const ref = useRef();
  const navigate = useNavigate()
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const location = useLocation();
  const opener = location.state ? location.state.opener : "";
  console.log("location")
  console.log(location)
  console.log(location.state)
  let backUrl = "/" + urlParts[3] + `/userdetail`;
  if (opener === "profile") {
    backUrl = "/" + urlParts[3] + `/userdetail`;
  }
  else if (opener === "request") {
    backUrl = "/" + urlParts[3] + `/imprestExpenseManagement`;
  }
  const toggleuser = 8;
  const toggleexpense = 2;
  const backroute = (toggleuser, toggleexpense) => {
    navigate(backUrl, { state: { toggleuser, toggleexpense } })
  }
  return (

    <div>
      <div className='flex-column flex-center  slip-container'>

        <div className='printSlip-width flex-row justify-evenly button-margin'>
          <button className="model-button  font-weight500    model-button-cancel font-size-heading" onClick={(e) => { backroute(toggleuser, toggleexpense) }}>Back</button>
          <ReactToPrint
            bodyClass="print-agreement"
            content={() => ref.current}
            trigger={() => (
              <button className='model-button model-button-black'>
                <Printer color={'white'} />{" "}
                Print
              </button>
            )}
          />
        </div>

        <ExpenseSlip ref={ref} />
      </div>
    </div>
  );
};


export default ExpenseSlipByExpense
